import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const alreadySignedContainer = css`
  margin-top: 56px;

  ${MEDIA_MIN_SM} {
    margin-top: 188px;
  }
`;

export const title = css`
  margin: var(${SpacingToken.Spacing0});
  margin-bottom: var(${SpacingToken.Spacing8});
`;

export const alreadySignedInButton = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing8});

  > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
